import React, { useEffect, useRef } from 'react';
import { heroData } from '../mock';

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = heroRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={heroRef} className="hero-section-clean">
      <div className="hero-content-clean">
        <h1 className="hero-headline-clean fade-in">{heroData.headline}</h1>
        <h2 className="hero-subheadline-clean fade-in">{heroData.subheadline}</h2>
        <p className="hero-description-clean fade-in">{heroData.description}</p>
      </div>
    </section>
  );
};

export default Hero;